import PropTypes from "prop-types";
import { Container } from "@ui/wrapper";
import SectionTitle from "@ui/section-title";
import { SectionTitleType, ItemType, MottoType } from "@utils/types";
import { SectionWrap,Subtitle } from "./style";
import Text from "@ui/text";


const PrivacyArea = ({ data }) => {
    return (
        <SectionWrap>
            <Container>
                    {data?.section_title && (
                        <SectionTitle
                            mb={["30px", null, "60px"]}
                            subtitle={data.section_title?.subtitle}
                            title={data.section_title?.title}
                        />
                    )}
                    {data?.headings.map((it,idx) => (
                        <Text>
                            {it.content}
                        </Text>
                    ))}
                    {data?.items.map((it,idx) => (
                        <div>
                            <Subtitle>{it.title}</Subtitle>
                            {it?.texts.map((item,index) => (<div>
                                    {item?.title && <h6>{item.title}</h6>}
                                    <Text style = {{textIndent:"2em"}}>{item.content}</Text>
                                </div>))}
                        </div>
                    ))}
                    <br/>
                    <Text>{data?.texts[0].content}</Text>
            </Container>
        </SectionWrap>
    );
};

PrivacyArea.propTypes = {
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
        items: PropTypes.arrayOf(PropTypes.shape(ItemType)),
        motto: PropTypes.shape(MottoType),
    }),
};

export default PrivacyArea;



// {data?.motto && (
//     <Motto
//         mt={["40px", null, "80px"]}
//         text={data.motto?.text}
//         linkText={data.motto?.linkText}
//         path={data.motto?.link}
//     />
// )}

// <SwiperSlider
//     dotStyle={2}
//     paginationTop="60px"
//     options={sliderSettings}
// >
//     {data.items?.map((project) => (
//         <SwiperSlide key={project.id}>
//             <Project
//                 title={project.title}
//                 images={project.images}
//                 path={project.path}
//             />
//         </SwiperSlide>
//     ))}
// </SwiperSlider>



